<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
      <div class="md-layout-item md-medium-size-100 md-size-50">
        <Login data-background-color="green" class="justify-center"></Login>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>
<script>
import Login from "../components/Login/Login.vue";
export default {
  components: {
    Login
  }
};
</script>
